// extracted by mini-css-extract-plugin
export default {"side-title-container":"UbnATB","sideTitleContainer":"UbnATB","side-title-heading":"BBrPJl","sideTitleHeading":"BBrPJl","side-subtitle":"ro0uC7","sideSubtitle":"ro0uC7"};